import { on } from '@ember/modifier';
import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';

import type { Service } from 'webapp-types';
import { UserAccess } from 'webapp/enums/enums';

import CommonUiIconComponent from 'webapp/components/common/ui-icon';
import UserInviteComponent from 'webapp/components/user/invite';

import type Board from 'webapp/models-custom/board';

export interface Args {
	model: Board;
	isContentShown: boolean;
	trackingOrigin: string; // TrackingOriginType from model-manager/boards
	onContentChange: () => void;
	onClose: () => void;
}

export default class BoardsShareUserAccessTabComponent extends Component<Args> {
	@service('model-manager/users') declare mmUsersService: Service.ModelManager.Users;
	@service('current-user') declare currentUserService: Service.CurrentUser;

	get showUserInvite() {
		return this.currentUserService.isAdmin;
	}

	get selectedUsersCount() {
		const users = this.args.model.users || [];
		return this.mmUsersService.activatedUserRecords.filter((user) => users.includes(+user.id!))
			.length;
	}

	get permissionsText() {
		switch (this.args.model.access) {
			case UserAccess.PUBLIC:
				return 'This dashboard is accessible to <strong>all users</strong> in your account.';
			case UserAccess.RESTRICTED:
				return `This dashboard is accessible to <strong>selected users (${this.selectedUsersCount})</strong> in your account.`;
			case UserAccess.PRIVATE:
				return 'This dashboard is private and accessible only to you.';
		}
		return '';
	}

	@action
	openBoardPermissions() {
		this.args.model.openBoardPermissions();
	}
	<template>
		<div class="content2 {{if @isContentShown 'content2--shown'}} user-access-tab">
			<div class="permissions">
				<p>{{{this.permissionsText}}}</p>
				<p>
					<a {{on "click" this.openBoardPermissions}}>
						<CommonUiIconComponent @name="UserAccess" @size="sm" />
						Change permissions
					</a>
				</p>
			</div>

			{{#if this.showUserInvite}}
				<div class="invite">
					<p><strong>Invite new users</strong> to join your account</p>
					<UserInviteComponent
						@initialNumberOfNewUsers={{2}}
						@onAdminInvite={{@onClose}}
						@onClose={{@onClose}}
						@onContentChange={{@onContentChange}}
						@trackingOrigin={{@trackingOrigin}}
						@ignoreEmptyFields={{true}}
					/>
				</div>
			{{/if}}

		</div>
	</template>
}
